import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_IMAGE_RESOURCES_QUERY_KEY = 'security-image-resources';

const getImageResourcesQueryKey = (tagId: string) =>
  [SECURITY_IMAGE_RESOURCES_QUERY_KEY, tagId] as const;

const getImageResourcesQueryOptions = (tagId: string) =>
  queryOptions({
    queryKey: getImageResourcesQueryKey(tagId),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getImageResources({
        tagId,
      });
      return data.items || null;
    },
  });

export const useImageResourcesQuery = (tagId: string) => {
  const {
    isLoading,
    data: affectedResources,
    error,
    refetch,
  } = useQuery(getImageResourcesQueryOptions(tagId));

  return {
    isLoading,
    affectedResources: affectedResources || undefined,
    error,
    refetch,
  };
};
